module.exports = __webpack_public_path__ + "static/img/1-1.f3e8b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/1-1.png
// module id = VTz9
// module chunks = 0